import { tryParseJSONObject } from '@fox/atoms/utils/string';
import { IBlockProps } from '@fox/blocks/contracts/block';
import { nanoid } from 'nanoid';
import { IField } from '../../../form-root/contracts';
import { FormRenderMode } from '../../../form-runtime-context/contracts';
import { useFormRuntimeContext } from '../../../form-runtime-context/form-runtime-context';
import { useFormBlockReRenderer } from '../../../use-form-block-re-renderer';
import { QuestionLabelRender } from '../../question-block/question-label';
import { SinglePersonSection } from './single-person-section';

export const SinglePersonBlock = ({ id, props }: IBlockProps<IField>) => {
	const { formRenderMode, getAnswer } = useFormRuntimeContext();
	useFormBlockReRenderer([props.name], props);
	const fieldProps = props;
	let currentAnswer = getAnswer(fieldProps.name) ?? {
		questionName: fieldProps?.name ?? 'CreatePerson',
		answer: {
			answerJson: JSON.stringify({
				contacts: [
					{
						id: nanoid()
					}
				]
			})
		} as any
	};

	const currentAnswerSelections = tryParseJSONObject(currentAnswer?.answer?.answerJson);

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: 5,
				marginBottom: 20,
				pointerEvents: formRenderMode !== FormRenderMode.design ? 'auto' : 'none'
			}}
		>
			<QuestionLabelRender style={{ fontSize: '1.25rem', padding: 0 }} value={fieldProps.title} id={id} />

			{formRenderMode !== FormRenderMode.design ? (
				<SinglePersonSection
					currentAnswer={currentAnswer}
					currentAnswerSelections={currentAnswerSelections}
					fieldProps={fieldProps}
					id={id}
					contact={currentAnswerSelections?.contacts?.[0]}
				/>
			) : (
				<SinglePersonSection
					currentAnswer={currentAnswer}
					currentAnswerSelections={currentAnswerSelections}
					fieldProps={fieldProps}
					id={id}
				/>
			)}
		</div>
	);
};
